import { DefaultJsonForm } from '../../../../components/v2/default-json-form'
import React from 'react'
import { IndividualTabProps } from './interfaces'

const IndividualTab : React.FC<IndividualTabProps> = ({ individualData, onChange }) => {
  const formData = individualData
  const schema = {
    properties: {
      birthday: {
        type: 'string',
        format: 'date',
        title: 'Дата рождения',
      },
      passport_number: {
        type: 'string',
        title: 'Серия и номер паспорта',
      },
      passport_issued: {
        type: 'string',
        title: 'Кем выдан паспорт',
      },
      registration_address: {
        type: 'string',
        title: 'Адрес регистрации',
        view: {
          name: 'input-text-dadata',
        },
      },
    },
    type: 'object'
  }

  const onChangeHandler = data => {
    onChange(data.formData)
  }

  return (
    <DefaultJsonForm
      orientation='horizontal'
      formData={formData}
      schema={schema}
      onChange={onChangeHandler}
    />
  )
}

export default IndividualTab